export enum SubscriptionInterval {
  Month = "month",
  Year = "year",
}
